<h2 tuiTitle>{{ metricName() }}</h2>

<div class="datapoint-list">
  @for (datapoint of visibleDatapoints(); track datapoint.key; let last = $last) {
    <div class="datapoint-block">
      <p class="datapoint-heading">
        {{ datapoint.name }}
        @if (datapoint.unitLabel) {
          [{{ datapoint.unitLabel }}]
        }
      </p>

      <app-performance-limits-table
        [value]="datapoint.value"
        [editable]="editable()"
        (valueChange)="onValueChange(datapoint.key, $event)"
        (invalidChange)="onInvalidChange(datapoint.key, $event)"
      />
    </div>

    @if (!last) {
      <hr class="datapoint-divider" />
    }
  }
</div>
